import { render, staticRenderFns } from "./TeachersItem.vue?vue&type=template&id=7d281dc2&scoped=true&"
import script from "./TeachersItem.vue?vue&type=script&lang=js&"
export * from "./TeachersItem.vue?vue&type=script&lang=js&"
import style0 from "./TeachersItem.vue?vue&type=style&index=0&id=7d281dc2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d281dc2",
  null
  
)

export default component.exports